export default function Prilohy(){
  return {
    restrict: "E",
    require: "?ngModel",
    template: require("./prilohy.html"),
    link: function(scope, element, attr, ngModelController){
      var $file = $("<input type='file'>");
      scope.readonly = attr.readonly!==undefined;
      var addFile = function(file){
        ngModelController.$viewValue.push({id: null, nazov: null, file: file});
        ngModelController.$setViewValue(ngModelController.$viewValue);
        ngModelController.$render();
      }

      $file.on("change", function(e){
        if($file[0].files[0]){
          addFile($file[0].files[0]);
        }
      });

      element.on("dragover", function(e){
        element.addClass("drop-active");
        e.preventDefault();
        e.stopPropagation();
      })

      element.on("dragleave", function(e){
        element.removeClass("drop-active");
        e.preventDefault();
        e.stopPropagation();
      })

      element.on("drop", function(e){
        element.removeClass("drop-active");
        var files = e.originalEvent.dataTransfer.files;
        if(files[0]) addFile(files[0]);
        e.preventDefault();
        e.stopPropagation();
      });

      scope.selectFile = function(){
        $file.click();
      }

      ngModelController.$render = function(){
          scope.prilohy = ngModelController.$viewValue;
      }


    }    
  }
}


// WEBPACK FOOTER //
// ./src/util/Prilohy.js